import { EQUIPMENT, FOCUS_AREA } from 'utils/constants/categories';
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { call, put, select, takeLatest } from 'redux-saga/effects';

import SDK from 'utils/sdk';
import { SELECT_MODAL_LIMIT_AMOUNT_OF_VIDEOS } from 'utils/constants/limit-videos';
import { SubmissionError } from 'redux-form';
import { messageError } from 'views/ui/toast-message';
import { getSelectedDateRange } from 'modules/video/selectors';
import { listVideo, setCount } from './actions';
import {
  getSelectVideoSearchEquipment,
  getSelectVideoSearchFocusArea,
  getSelectVideoSearchTerm,
  getOrder,
  getSort,
  getSkip,
} from './selector';

export function* listVideoSaga() {
  try {
    yield put(listVideo.request());

    const searchTerm = yield select(getSelectVideoSearchTerm);
    const searchFocusArea = yield select(getSelectVideoSearchFocusArea);
    const searchEquipment = yield select(getSelectVideoSearchEquipment);
    const dateRange = yield select(getSelectedDateRange);
    const order = yield select(getOrder);
    const sort = yield select(getSort);
    const skip = yield select(getSkip);

    let dateRangeRequest = {
      skip,
    };
    if (dateRange.startDate) {
      dateRangeRequest = {
        startDate: dateRange.startDate.toISOString(),
        endDate: dateRange.endDate.toISOString(),
      };
    }
    if (order) {
      dateRangeRequest = {
        ...dateRangeRequest,
        order,
      };
    }
    if (sort) {
      dateRangeRequest = {
        ...dateRangeRequest,
        sort,
      };
    }

    const requestBody = {
      exercise_name: searchTerm === '' ? null : searchTerm,
      equipment: searchEquipment === EQUIPMENT ? null : searchEquipment,
      focus_area: searchFocusArea === FOCUS_AREA ? null : searchFocusArea,
    };

    const client = yield call([SDK, 'getClient']);
    const { data } = yield call(
      [client, 'videoListSearch'],
      {
        limit: SELECT_MODAL_LIMIT_AMOUNT_OF_VIDEOS,
        ...dateRangeRequest,
      },
      requestBody
    );

    const { count, results } = data;
    yield put(setCount(count));
    yield put(listVideo.success(results));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    messageError(data);
    yield put(
      listVideo.failure(
        new SubmissionError({
          _error: data,
        })
      )
    );
  } finally {
    yield put(listVideo.fulfill());
  }
}

export default function* selectVideoWatch() {
  yield takeLatest(listVideo.TRIGGER, listVideoSaga);
}
